import { defineStore } from 'pinia'

export const useDocumentTitleStore = defineStore('documentTitle', {
  state: () => ({
    title: 'Главная страница',
  }),
  actions: {
    // Обновление массива дочерних пунктов меню
    set (value: string) {
      if (value) {
        this.title = value
        document.title = value
      }
    }
  },
  getters: {
    getDocumentTitle: (state): string => state.title,
  }
})
